import React, { Component } from 'react';
import PropTypes from 'prop-types';

import red from '@material-ui/core/colors/red';
import QueryString from 'query-string';
import { PasswordField, Button, LoadingIndicator, AppBar } from '../components';
import { ThemeImages, ThemeColors } from '../theme';

class ResetPassword extends Component {

  constructor(props) {
    super(props);
    const { resetToken, userId } = QueryString.parse(props.location.search);

    this.state = {
      password: '',
      passwordConfirm: '',
      resetToken,
      userId,
    };

    this.setPassword = this.setPassword.bind(this);
    this.setPasswordConfirm = this.setPasswordConfirm.bind(this);
    this.keyPress = this.keyPress.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
  }

  setPassword(event) {
    this.setState({ password: event.target.value });
  }

  setPasswordConfirm(event) {
    this.setState({ passwordConfirm: event.target.value });
  }

  keyPress(event) {
    if (event.key === 'Enter') {
      this.resetPassword();
      event.preventDefault();
      return false;
    }
    return true;
  }

  resetPassword() {
    if (this.state.password && this.state.password !== '' && this.state.passwordConfirm === this.state.password) {
      this.props.resetPassword({
        password: this.state.password,
        resetToken: this.state.resetToken,
        userId: this.state.userId,
      });
    }
  }

  render() {
    const formGroupStyle = {
      width: '100%',
      textAlign: 'center',
    };

    const containerStyle = {
      width: '300px',
      margin: '0 auto',
      marginTop: 'calc(50vh - 215px)',
      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.75)',
    };

    const errorContainerStyle = {
      backgroundColor: red[500],
      textAlign: 'center',
      color: 'white',
    };

    const RequestErrorMessage = (props) => {
      if (!props.errorMessage) {
        return null;
      }

      return (
        <div style={errorContainerStyle}>
          <span>{props.errorMessage}</span>
        </div>
      );
    };

    const PasswordErrorMessage = () => {
      if (!this.state.confirmTouched || this.state.password === this.state.passwordConfirm) {
        return null;
      }

      return (
        <div style={errorContainerStyle}>
          <span>Passwörter stimmen nicht überein!</span>
        </div>
      );
    };

    const ResetPasswordButton = (props) => {
      if (props.loading) {
        return <LoadingIndicator />;
      }

      const disabled = !this.state.password
        || this.state.password === ''
        || this.state.password !== this.state.passwordConfirm;

      return (<Button
        label="Passwort ändern"
        style={{ color: ThemeColors.darkTextOnPrimaryBackground ? 'black' : 'white' }}
        onClick={this.resetPassword}
        disabled={disabled}
        color="primary"
        variant={!disabled ? 'contained' : 'default'}
      />);
    };

    if (!this.state.resetToken || this.state.resetToken === '' || !this.state.userId || this.state.userId === '') {
      return (
        <div style={{ ...containerStyle, padding: 20 }}>
          <h1>Ungültige Anfrage</h1>
          <p>Passwort-ResetToken und UserId werden für diesen Vorgang benötigt.</p>
        </div>
      );
    }

    return (
      <form style={containerStyle} onKeyPress={this.keyPress} noValidate>
        <div style={{ padding: 20 }}>
          <img src={ThemeImages.logoPath} alt="Logo" style={{ width: '100%' }} />
        </div>
        <AppBar title="Neues Passwort" defaultTypography />
        <RequestErrorMessage {...this.props} />
        <PasswordErrorMessage />
        <div
          style={{
            ...formGroupStyle,
            marginTop: 10,
          }}
        >
          <PasswordField
            autoFocus
            required
            hintText="Passwort"
            value={this.state.password}
            onChange={this.setPassword}
          />
        </div>
        <div style={formGroupStyle}>
          <PasswordField
            required
            hintText="Passwort wiederholen"
            value={this.state.passwordConfirm}
            onChange={this.setPasswordConfirm}
            onBlur={() => this.setState({ confirmTouched: true })}
          />
        </div>
        <div
          style={{
            ...formGroupStyle,
            marginTop: 20,
            paddingBottom: 10,
          }}
        >
          <ResetPasswordButton {...this.props} />
        </div>
      </form>
    );
  }
}

ResetPassword.propTypes = {
  resetPassword: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/app/resetpassword/resetpassword.js